var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Template1"
  }, [_c('div', {
    staticClass: "card-header-tab"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button ', {
        active: _vm.currentTab === tab.key
      }],
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab.value) + "\n      "), (tab.value == 'Services') ? _c('span', {
      attrs: {
        "id": "first"
      }
    }, [_c('i', {
      staticClass: "fa fa-bars"
    })]) : _vm._e(), _vm._v(" "), (tab.value == 'Rates') ? _c('span', {
      attrs: {
        "id": "second"
      }
    }, [_c('i', {
      staticClass: "fa fa-percent"
    })]) : _vm._e(), _vm._v(" "), (tab.value == 'T&C') ? _c('span', {
      attrs: {
        "id": "third"
      }
    }, [_c('i', {
      staticClass: "fa fa-info"
    })]) : _vm._e(), _vm._v(" "), (tab.value == 'Annexures') ? _c('span', {
      attrs: {
        "id": "fourth"
      }
    }, [_c('i', {
      staticClass: "fa fa-certificate"
    })]) : _vm._e()])
  })), _vm._v(" "), (_vm.currentTab == 'First') ? _c('div', [_c('Service-View', {
    attrs: {
      "selectedEdit": _vm.selectedEditRow
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'Second') ? _c('div', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Rates")])]), _vm._v(" "), _c('div', [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "items": _vm.tableItems,
      "innerTableHeader": _vm.innerTableColumn,
      "offset": _vm.offset,
      "isEditHidden": true
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }, [_c('RateTemplateView', {
    ref: "childRateViewComponentFromListing"
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.contractServiceList && _vm.contractServiceList.length > 0) ? _c('div', {
    staticClass: "card-headerfrm1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Contracted Services")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Truck Load Type ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Route Mode")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Service Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Booking Type")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.contractServiceList), function(column, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(column.truckloadtype))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(column.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(column.servicetype))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(column.bookingtype.join(", ")))])])
  }))]), _c('br')]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'Third') ? _c('div', [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n            Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n            Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "clientcontracttc",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("Billing Terms")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_c('strong', [_vm._v("Billing Cycle : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.billingCycle))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('strong', [_vm._v("POD Hard Copy required : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.pod))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.billingCycle && _vm.billingCycle != 'Weekly') ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_c('strong', [_vm._v("Last Date for Bill Submission : ")])]), _vm._v(" "), (_vm.billingCycle) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Cycle")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Day of the Month(1-31)")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.date1))])]), _vm._v(" "), (_vm.billingCycle == 2 || _vm.billingCycle == 'Fortnightly') ? _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.date2))])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pod == 'Yes') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('strong', [_vm._v("POD Hard Copy Charges (INR per POD) : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.podCharge))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "clientcontracttc",
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("Credit and Payment Terms")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_c('strong', [_vm._v("Credit Period (Days) : ")]), _vm._v(_vm._s(_vm.creditPeriod)), _c('br'), _vm._v("(From Date of Submission of Bill): ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_c('strong', [_vm._v("Credit Limit (INR) : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.creditLimit))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_c('strong', [_vm._v("Advance Payment % : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.advancePayment))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_c('strong', [_vm._v("Credit Limit Alert % :")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.creditAlert))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("(For FTL Mode Only)")])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "form-group row checkbox"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_c('strong', [_vm._v("Payment Mode : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.paymentmode))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("In favour of "), _c('b', [_vm._v("Busybees Logistics Solutions Pvt. Ltd")])])]), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "clientcontracttc",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("Other Terms and Conditions")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('strong', [_vm._v("Max Liability")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_c('strong', [_vm._v("Max Liability Amount (INR) : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.liabilityAmount))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("COF to be issued for lost,damaged or pilferage in case liability is more than maximum liability amount")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('strong', [_vm._v("COF (Certificate of Fact)")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Shipment will be accepted for transportation on the owner's risk basis. The shipper\n                    is required to make his own transit insurance . In the event of any unforeseen circumstances or damage or loss\n                    ,the certificate of fact (COF) will be issued by XpressBees .")])])])])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'Fourth') ? _c('div', [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Annexures")])])]), _vm._v(" "), _c('table', {
    staticClass: "styled-table ",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-left tableheader"
  }, [_c('b', [_vm._v("Annexure Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('b', [_vm._v("Description")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('b', [_vm._v("Upload Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Document")])])])]), _vm._v(" "), _c('tbody', [(_vm.AnnexureList.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No Records Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.AnnexureList), function(column, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(column.annexurename))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(column.annexuredscription))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(_vm.format_date(column.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "download"
      },
      on: {
        "click": function($event) {
          _vm.fileview(column.annexureurl)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true",
        "title": "Download Document"
      }
    })])])])
  })], 2)])])], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48ca21a4","hasScoped":true}!./src/modules/masterdata/views/contracttemplate/contracttemplateview/contracttemplateview.component.html
// module id = 680
// module chunks = 3